import { ORDER_APIS } from "@/api_framework/api_config";
import { IOderManagementActionBody, IOrderManagementActionItemsResponse } from "@/api_framework/api_modals/Orders";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type IQCUpdateAPIResponse = { status: boolean; message: string };

// returns new created userId
export const useOrderManagementExaclationAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (formData: IOderManagementActionBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response: IQCUpdateAPIResponse = await axios
          .put(`${ORDER_APIS?.ORDER_ACTION_EXCELATION_BUTTON?.baseURL}`, formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<IOrderManagementActionItemsResponse>) => {
            if (res.data.status === true) {
              toast.success("Escalation send successfully");
              return { status: true, message: "batch" };
            } else {
              toast.error(`Escalation send Faild please contact to Tech Team.`);
              return { status: false, message: "batch" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
            return { status: false, message: "batch" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
